import { Box, MenuItem, Select, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PrintDownloadButton from '../../common/button/printDownloadButton';
import { MdDownload, MdVisibility } from 'react-icons/md';
import DataTable from '../../common/dataTable';
import DangerButton from '../../common/button/DangerButton';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import masterActions from "../../redux/master/actions";
import objectionTrackerActions from '../../redux/objectionTracker/actions';
import DataTableModified from '../../common/dataTableModified';

const Index = ({ role }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
const [searchParams] =useSearchParams();
const cid = searchParams?.get('cid')
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [showTable, setShowTable] = useState(false);


  const handleSelectQuestion = (questionno) => {
    setShowTable(false)

    setSelectedQuestion(questionno);
  };

  const handleSelectCourse = (courseid) => {
    setShowTable(false)

    setSelectedCourseId(courseid);
    setSelectedQuestion('');
    setShowTable(false);
    dispatch({
      type: objectionTrackerActions.GET_OBJECTION_QUESTION_DETAILS,
      payload: { courseid },
    });
  };

  const { courseList,courseListAdmin } = useSelector((state) => state.masterReducer);
  const objQuestionDetails = useSelector((state) => state.objectionTrackerReducer?.objQuestionDetails);
  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);



const courseIds = courseListAdmin?.all?.length 
  ? courseListAdmin.all[0]?.courses?.split(',').map(Number) 
  : [];

const filteredCourseList = courseList?.all?.filter((item) =>
  courseIds?.includes(Number(item?.courseid)) // Ensure both are numbers
);



  const uniqueObjQuestions = objQuestionDetails?.filter(
    (item, index, self) => index === self?.findIndex((q) => (q?.questionno === item?.questionno && item?.status == 1 ))
  )?.sort((a,b)=>parseInt(a?.questionno) - parseInt(b?.questionno))

  useEffect(() => {
    dispatch({ type: masterActions?.GET_COURSE_LIST });
  
    
    dispatch({ type: masterActions.GET_COURSE_LIST_BY_ADMIN,payload:{id:backofficeTokenDetails?.id} });
  }, [backofficeTokenDetails]);
  useEffect(() => {
    const storedCourseId = sessionStorage.getItem("selectedCourseId");
    const storedQuestion = sessionStorage.getItem("selectedQuestion");
  
    if (storedCourseId) {
      setSelectedCourseId(storedCourseId);
   
      dispatch({
        type: objectionTrackerActions.GET_OBJECTION_QUESTION_DETAILS,
        payload: { courseid: storedCourseId },
      });
     
    }
    if(cid){
      
if(cid == null){
  
  setSelectedCourseId(null);

} 
     setSelectedCourseId(cid);

    }
  
    if (storedQuestion) {
      setSelectedQuestion(storedQuestion);
    }

    setShowTable(true)
  }, [courseListAdmin]);
  
  const columnData = [
    { name: 'Question Id', accessor: 'questionid' },
    { name: 'Question Details', accessor: 'questiondetails' },
    { name: 'Answer Key Response', accessor: 'answerkey' },
    // { name: 'Reference Details', accessor: 'referenceid' },
    { name: 'Action', accessor: 'action' },
  ];

  const filteredData = selectedQuestion
    ? objQuestionDetails?.filter((item) => item.questionno == selectedQuestion)
    : [];
    const sortedData = filteredData?.sort((a, b) => {
      if (a.isreviewerapproved === null) return -1;
      if (b.isreviewerapproved === null) return 1;
      return b.isreviewerapproved - a.isreviewerapproved;
    });
    const tableData = sortedData?.map((item) => {
      let buttonLabel = "View";
      if (item.isreviewerapproved == 0) {
        buttonLabel = "Rejected";
      } else if (item.isreviewerapproved == 1) {
        buttonLabel = "Approved";
      }
    
      return {
        questionid: item?.questionid,
        questiondetails:<> 
        <Box sx={{display:"flex",justifyContent:"center",alignItems:"center"}}><Box >
           <img src={item?.questiondetails} height={"200px"} width={"90%"} alt='question'/>
          </Box>
          </Box>
           </>,
        answerkey: item?.answerkey,
        referenceid: item?.referenceid,
        action: (
          <DangerButton 
            handleSubmit={() => handleSubmit(item.objectionquestionid, selectedCourseId)} 
            title={buttonLabel} 
          />
        )
      };
    });
    
  // const handleSubmit = (objid, courseid) => {
  //   navigate(`/${Cookies.get('mhet_mst_project')}/view-single-objection?objid=${objid}&courseid=${courseid}`);
  // };

  const handleSubmit = (objid, courseid) => {
    sessionStorage.setItem("selectedCourseId", selectedCourseId);
    sessionStorage.setItem("selectedQuestion", selectedQuestion);
    navigate(`/${Cookies.get('mhet_mst_project')}/view-single-objection?objid=${objid}&courseid=${courseid}`);
  };
  

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 2 }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Select value={selectedCourseId == null ? 0 :selectedCourseId ?selectedCourseId : 0} onChange={(e) => handleSelectCourse(e.target.value)} size="small"
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 200, // Set a max height for scroll
                    overflowY: "auto",
                  },
                },
              }}
            
            >
            <MenuItem disabled value={0 || 'null'}>Course Name</MenuItem>
            {filteredCourseList?.map((item) => (
              <MenuItem key={item.courseid} value={item.courseid}>{item.coursename}</MenuItem>
            ))}
          </Select>
          <Select value={selectedQuestion || 0} onChange={(e) => handleSelectQuestion(e.target.value)} size="small" disabled={!selectedCourseId}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 200, // Set a max height for scroll
                    overflowY: "auto",
                  },
                },
              }}
            >
            <MenuItem disabled value={0}>Select Question No</MenuItem>
            {uniqueObjQuestions?.map((item) => (
              <MenuItem key={item.questionno} value={item.questionno}>{item.questionno}</MenuItem>
            ))}
          </Select>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Button
            variant="contained"
            startIcon={<MdVisibility />}
            onClick={() => setShowTable(true)}
            disabled={!selectedQuestion}>
            View Raised Objection
          </Button>
        </Box>
      </Box>
      {showTable && tableData?.length > 0 && (
        <Box>
          <DataTableModified keys={columnData} values={tableData} />
        </Box>
      )}
    </>
  );
};

export default Index;
